import * as $ from 'jquery';
import { Component, OnInit, ViewChild, AfterViewInit, OnDestroy, HostListener } from '@angular/core';
import { MatTabChangeEvent } from '@angular/material/tabs';
import { MatTableDataSource } from '@angular/material/table';
import { MatSort } from '@angular/material/sort';
import { MatPaginator } from '@angular/material/paginator';
import { MatDialog } from '@angular/material/dialog';
import { SelectionModel } from '@angular/cdk/collections';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { DatePipe } from '@angular/common';
const _ = require('lodash');

import { DashboardFilter } from '../../../../../app/models/DashboardFilter';
import { MasterConstants } from '../../../../../app/common/constants/master-constants';
import { ConfirmDialogComponent } from './../../../../common/components/confirm-dialog/confirm-dialog.component';

import { LocalStorageService } from './../../../../services/infrastructure/local-storage.service';
import { SeedFulfillmentService } from './../../../../services/seed/seed-fulfillment.service';
import { LoaderService } from './../../../../services/infrastructure/loader.service';
import { ExcelService } from './../../../../services/infrastructure/excel.service';
import { Subscription, forkJoin } from 'rxjs';
import { LolLoggerService } from './../../../../common/shared/lol-logger.service';
import { CommonService } from '../../../../services/common/common.service';

@Component({
  selector: 'app-landing-seed-fulfillment',
  templateUrl: './landing-seed-fulfillment.component.html',
  styleUrls: ['./landing-seed-fulfillment.component.scss']
})
export class LandingSeedFulfillmentComponent implements OnInit, AfterViewInit, OnDestroy {
  private subscription = new Array<Subscription>();

  filterArray = [];
  // isFulfillment = true;
  headerYear: any;
  headerCompany = MasterConstants.US_COMPANYCODE;
  dashboardFilter: DashboardFilter;
  bodyDS: any;
  itemList: number[];

  @ViewChild('unSubmittedTable', { read: MatSort }) unSubmittedSort: MatSort;
  @ViewChild('unSubmittedPaginator', { read: MatPaginator }) unSubmittedPaginator: MatPaginator;

  @ViewChild('submittedTable', { read: MatSort }) submittedSort: MatSort;
  @ViewChild('submittedPaginator', { read: MatPaginator }) submittedPaginator: MatPaginator;

  public unsubmittedList: any;
  public unsubmittedDataSource: MatTableDataSource<any>;
  public unsubmittedSelection = new SelectionModel<any>(true, []);
  public submittedSelection = new SelectionModel<any>(true, []);

  public submittedList: any;
  public submittedDataSource: MatTableDataSource<any>;

  displayedunSubmittedColumns: string[] = ['releaseId', 'accountNumber', 'branchPlant', 'requestDate', 'dealerReleaseNumber', 'totalUnit', 'orderType'];
  displayedsubmittedColumns: string[] = ['releaseId', 'accountNumber', 'branchPlant', 'requestDate', 'dealerReleaseNumber', 'jdereleaseOrderNumber', 'orderType'];
  seedFulfillmentFilter: any;

  selectedCount = 0;
  selectedSubmittedCount = 0;
  accessTypeMode = false;

  constructor(private router: Router,
    private localStorageService: LocalStorageService,
    private seedFulfillmentService: SeedFulfillmentService,
    private dialog: MatDialog,
    private loaderService: LoaderService,
    private excelService: ExcelService,
    private toastrService: ToastrService,
    private datePipe: DatePipe,
    private commonService: CommonService) {
    this.dashboardFilter = new DashboardFilter();
  }

  @HostListener('window:resize', ['$event']) onresize(event) {
    this.setHeight();
  }

  ngOnInit() {
    this.filterArray = [
      { label: 'Account Number', column: 'account' },
      { label: 'Account Name', column: 'accountName' },
      { label: 'City', column: 'city' },
      { label: 'State / Province', column: 'state' },
      { label: 'Product Name', column: 'productName' },
      { label: 'Item Number', column: 'itemNumber' },
      { label: 'Marketing Brand', column: 'marketingBrand' },
      { label: 'Seed Size', column: 'seedSize' },
      { label: 'Package Size', column: 'packageSize' },
      { label: 'Product Category', column: 'productCategory' },
      { label: 'Treatment', column: 'treatment' },
      { label: 'Product Line', column: 'productLine' },
      { label: 'Product Segment', column: 'productSegment' },
      { label: 'Hybrid Variety', column: 'hybridVariety' },
      { label: 'Dealer Zip', column: 'dealerZip' },
      { label: 'Branch Plant', column: 'branchPlant' },
      { label: 'Order Type', column: 'orderType' }];

    // Set the default value
    if (this.localStorageService.get(MasterConstants.HEADER_CROP_YEAR)) {
      this.headerYear = JSON.parse(this.localStorageService.get(MasterConstants.HEADER_CROP_YEAR));
    }

    this.getUnsubmittedDraftList();
    this.getSubmittedRequestList();

    this.accessTypeMode = false;
    setTimeout(x => {
      this.accessTypeMode = this.commonService.checkUserRoleAccessType(MasterConstants.FUNCTION_CODE.FULFILLMENT_TAB);
    }, 500);
  }

  // ngAfterViewInit
  ngAfterViewInit() {
    // Set Dynamic Height of Panels
    this.setHeight();
  }

  // Tab changed
  tabChanged = (tabChangeEvent: MatTabChangeEvent): void => {
    this.setHeight();
  };

  // Set Height
  setHeight() {
    setTimeout(function () {
      const templateHeight = window.innerHeight - $('.account-filter').outerHeight() - $('.mat-mdc-tab-header').outerHeight() - $('.fulfill-top-sec').outerHeight() - 187;
      $('.dealertableContainer').css('max-height', templateHeight + 'px');
      $('.growertableContainer').css('max-height', templateHeight + 'px');
    }, 100);
  }

  addEditSeedFulfillment() {
    this.router.navigate(['/seed-fulfillment', 0, 0]);
  }

  unsubmitedDeleteAction() {
    if (this.unsubmittedSelection.selected.length > 0) {
      const title = 'Are you sure you want to delete selected Items(s)?';
      const message = '';
      const dialogRef = this.dialog.open(ConfirmDialogComponent, {
        disableClose: true,
        width: '480px',
        data: { title: title, message: message, labelYes: 'Yes', labelNo: 'Cancel', dialogType: 'confirm' }
      });
      this.subscription.push(dialogRef.afterClosed().subscribe(result => {
        // If user selected Yes
        if (result == true) {
          this.loaderService.setLoaderStatus(true);
          if (this.unsubmittedSelection.selected.length > 0) {
            this.subscription.push(this.seedFulfillmentService.releaseOrderDelete(this.unsubmittedSelection.selected).subscribe((result: any) => {
              if (result) {
                this.unsubmittedList = result;
                this.unsubmittedDataSource = new MatTableDataSource(this.unsubmittedList);
                this.unsubmittedDataSource.paginator = this.unSubmittedPaginator;
                this.unsubmittedDataSource.sort = this.unSubmittedSort;
              }
              else {
                this.unsubmittedList = [];
                this.unsubmittedDataSource = new MatTableDataSource(this.unsubmittedList);
                this.unsubmittedDataSource.paginator = this.unSubmittedPaginator;
                this.unsubmittedDataSource.sort = this.unSubmittedSort;
              }
              this.unsubmittedSelection.clear();
              this.selectedCount = 0;
              this.loaderService.setLoaderStatus(false);
            }, (error => {
              LolLoggerService.error(error);
              this.loaderService.setLoaderStatus(false);
            })));
          }
          else {
            this.loaderService.setLoaderStatus(false);
          }
        }
        else {
          this.loaderService.setLoaderStatus(false);
        }
      }));
    }
  }

  unsubmitedReleaseToJDE() {
    if (this.unsubmittedSelection.selected.length > 0) {
      let isAllValidRequestDate = true;
      let isAllValidFreightHandlingCode = true;
      let isAllValidTotalUnits = true;
      const todayDate = new Date();
      todayDate.setHours(0, 0, 0, 0);
      this.unsubmittedSelection.selected.forEach(x => {
        const reqDate = new Date(x.requestDate);
        if (reqDate < todayDate) {
          isAllValidRequestDate = false;
        }
        if (x.freightHandlingCode == null) {
          isAllValidFreightHandlingCode = false;
        }
        if (x.totalUnit == null || x.totalUnit == 0) {
          isAllValidTotalUnits = false;
        }
      });

      if (isAllValidRequestDate === true && isAllValidFreightHandlingCode === true && isAllValidTotalUnits === true) {
        const releaseMessage = (this.unsubmittedSelection.selected.length > 1 ? 'multiple Release' : 'Release#: ' + this.unsubmittedSelection.selected[0].releaseId);
        var title = 'Please confirm submission of ' + releaseMessage + ' to create fulfillment order in ERP system.';
        var message = 'Once this request is submit, it may not be changed. The request will be available for viewing in the Submitted Requests group.';
        const dialogRef = this.dialog.open(ConfirmDialogComponent, {
          disableClose: true,
          width: '480px',
          data: { title: title, message: message, labelYes: 'Yes', labelNo: 'Cancel', dialogType: 'confirm' }
        });
        this.subscription.push(dialogRef.afterClosed().subscribe(result => {
          if (result == true) {
            this.loaderService.setLoaderStatus(true);
            if (this.unsubmittedSelection.selected.length > 0) {
              this.unsubmittedSelection.selected;
              this.subscription.push(this.seedFulfillmentService.placeMutileJDEOrder(this.unsubmittedSelection.selected).subscribe((result: any) => {
                if (result) {
                  this.unsubmittedList = result;
                  this.unsubmittedDataSource = new MatTableDataSource(this.unsubmittedList);
                  this.unsubmittedDataSource.paginator = this.unSubmittedPaginator;
                  this.unsubmittedDataSource.sort = this.unSubmittedSort;
                }
                else {
                  this.unsubmittedList = [];
                  this.unsubmittedDataSource = new MatTableDataSource(this.unsubmittedList);
                  this.unsubmittedDataSource.paginator = this.unSubmittedPaginator;
                  this.unsubmittedDataSource.sort = this.unSubmittedSort;
                }
                this.unsubmittedSelection.clear();
                this.selectedCount = 0;
                this.loaderService.setLoaderStatus(false);
              }, error => {
                LolLoggerService.error(error);
                this.loaderService.setLoaderStatus(false);
                this.toastrService.error('Something went wrong!');
              }));
            }
            else {
              this.loaderService.setLoaderStatus(false);
            }
          }
          else {
            this.loaderService.setLoaderStatus(false);
          }
        }));
      }
      else {
        if (!isAllValidRequestDate) {
          var title = 'Error';
          var message = 'You can\'t submit selected item(s) to ERP because some selected item(s) request date is less than today date.';
          this.dialog.open(ConfirmDialogComponent, {
            disableClose: true,
            width: '480px',
            data: { title: title, message: message, isYesEnable: false, labelNo: 'Ok', dialogType: 'confirm' }
          });
        }
        else if (!isAllValidFreightHandlingCode) {
          var title = 'Error';
          var message = 'You can\'t submit selected item(s) to ERP because FreightHandlingCode is not provided.';
          this.dialog.open(ConfirmDialogComponent, {
            disableClose: true,
            width: '480px',
            data: { title: title, message: message, isYesEnable: false, labelNo: 'Ok' }
          });
        }
        else if (!isAllValidTotalUnits) {
          var title = 'Error';
          var message = 'You can\'t submit selected item(s) to ERP because Total Units must be greater than Zero.';
          this.dialog.open(ConfirmDialogComponent, {
            disableClose: true,
            width: '480px',
            data: { title: title, message: message, isYesEnable: false, labelNo: 'Ok', dialogType: 'confirm' }
          });
        }
      }
    }
    else {
      LolLoggerService.info('no rows selected');
    }
  }

  getUnsubmittedDraftList() {
    this.unsubmittedSelection.clear();
    this.selectedCount = 0;
    this.loaderService.setLoaderStatus(true);
    this.dashboardFilter.cropYear = this.headerYear;
    this.dashboardFilter.companyCode = this.headerCompany;
    this.subscription.push(this.seedFulfillmentService.getUnsubmittedDraftList(this.dashboardFilter).subscribe(result => {
      this.unsubmittedList = result;
      this.unsubmittedDataSource = new MatTableDataSource(this.unsubmittedList);
      this.unsubmittedDataSource.paginator = this.unSubmittedPaginator;
      this.unsubmittedDataSource.sort = this.unSubmittedSort;
      this.loaderService.setLoaderStatus(false);
    }, (error => { LolLoggerService.error(error); this.loaderService.setLoaderStatus(false); })));
  }

  getSubmittedRequestList() {
    this.submittedSelection.clear();
    this.selectedSubmittedCount = 0;
    this.loaderService.setLoaderStatus(true);
    this.dashboardFilter.cropYear = this.headerYear;
    this.dashboardFilter.companyCode = this.headerCompany;
    this.subscription.push(this.seedFulfillmentService.getSubmittedRequestList(this.dashboardFilter).subscribe(result => {
      this.submittedList = result;
      this.submittedDataSource = new MatTableDataSource(this.submittedList);
      this.submittedDataSource.paginator = this.submittedPaginator;
      this.submittedDataSource.sort = this.submittedSort;
      this.loaderService.setLoaderStatus(false);
    }, (error => {
      LolLoggerService.error(error);
      this.loaderService.setLoaderStatus(false);
    })));
  }

  getUnSubmittedReport() {
    this.loaderService.setLoaderStatus(true);
    this.itemList = [];

    this.unsubmittedSelection.selected.forEach(x => {
      this.itemList.push(x.releaseId);
    });

    const data = {
      CropYear: this.headerYear,
      CompanyCode: this.headerCompany,
      ReleaseIds: this.itemList,
    };
    this.bodyDS = [];
    this.subscription.push(this.seedFulfillmentService.getUnSubmittedReport(data).subscribe(result => {
      this.bodyDS = result;
      this.exportAsXLSX(false);
    }, (error => {
      LolLoggerService.error(error);
      this.loaderService.setLoaderStatus(false);
    })));
  }

  getSubmittedReport() {
    this.loaderService.setLoaderStatus(true);
    this.itemList = [];

    this.submittedSelection.selected.forEach(x => {
      this.itemList.push(x.releaseId);
    });

    const data = {
      CropYear: this.headerYear,
      CompanyCode: this.headerCompany,
      ReleaseIds: this.itemList,
    };
    this.bodyDS = [];
    this.subscription.push(this.seedFulfillmentService.getSubmittedReport(data).subscribe(result => {
      this.bodyDS = result;
      this.exportAsXLSX(true);
    }, (error => {
      LolLoggerService.error(error);
      this.loaderService.setLoaderStatus(false);
    })));
  }

  // Code to call the export service and write data to the file name mentioned
  exportAsXLSX(isSubmittedReport: boolean) {
    const exportData = [];
    if (this.bodyDS && this.bodyDS.length > 0) {
      this.bodyDS.forEach(x => {
        exportData.push({
          'Dealer Order': x.dealerOrder,
          'ReleaseId': x.releaseID,
          'JDE Release OrderNo': x.jdeReleaseOrderNumber,
          'Branch PlantNo': x.branchPlantNo,
          'Branch Plant': x.branchPlant,
          'Ship To Account': x.accountNumber,
          'Ship To Address': x.shipToAccount + (x.shipToAddress == undefined ? '' : x.shipToAddress + '  ')
            + (x.shipToCity == undefined ? '' : x.shipToCity + '  ')
            + (x.shipToState == undefined ? '' : x.shipToState + '  ')
            + (x.shipToZipCode == undefined ? '' : x.shipToZipCode + '  ')
            + (x.shipToPhoneNo == undefined ? '' : x.shipToPhoneNo),
          'Deliver To Account': x.deliverToAccount,
          'Deliver To Address': x.deliverToAccount == null ? '' : (x.deliverToAddress == undefined ? '' : x.deliverToAddress + '  ')
            + (x.deliverToCity == undefined ? '' : x.deliverToCity + '  ')
            + (x.deliverToState == undefined ? '' : x.deliverToState + '  ')
            + (x.deliverToZipCode == undefined ? '' : x.deliverToZipCode + '  ')
            + (x.deliverToPhoneNo == undefined ? '' : x.deliverToPhoneNo),
          'Requested Date': this.datePipe.transform(x.requestedDate, 'MM-dd-yyyy'), // x.requestedDate,
          'Company Code': x.companyCode,
          'Delivery Instruction': x.deliveryInstructions,
          'Freight Handling Code': x.freightHandlingCode,
          'Request Type': x.jdeOrderType,
          'Created By': x.createUser,
          'Created Date': this.datePipe.transform(x.createTimestamp, 'MM-dd-yyyy h:mm:ss a'),// x.createTimestamp,
          'Item Number': x.itemNumber,
          'GTIN': x.gtin,
          'JDE Line No': x.jdeLineNumber,
          'Status': x.itemStatus,
          'Description': x.itemDescription,
          'Brand': x.brand,
          'Product Segment': x.productSegment,
          'Product line': x.productLine,
          'Marketing Brand': x.marketingBrand,
          'Hybrid Variety': x.hybridVariety,
          'Technology': x.technology,
          'Treatment': x.treatment,
          'PackageSize': x.packageSize,
          'Maturity': x.maturity,
          'Conversion Factor': x.conversionFactor,
          'Total Order Units': x.doiQuantity,
          'Hard Committed': x.hardQuantity,
          'Soft Committed': x.softQuantity,
          'Available To Release': x.availableUnits,
          'Release Quantity': x.quantity,
          'On hand Inventory': x.inventoryQty,
          'UOM': x.unitOfMeasurePrimary
        });
      });
      if (isSubmittedReport) {
        this.excelService.exportAsExcelFile(exportData, 'SubmittedReleaseItems');
      } else {
        this.excelService.exportAsExcelFile(exportData, 'UnSubmittedReleaseItems');
      }
      this.loaderService.setLoaderStatus(false);
    }
  }

  isAllUnsubmittedDraftSelected() {
    const numSelected = this.unsubmittedSelection.selected.length;
    const numRows = this.unsubmittedDataSource.data.length;
    return numSelected === numRows;
  }

  masterToggleUnsubmitted() {
    this.isAllUnsubmittedDraftSelected() ?
      this.unsubmittedSelection.clear() :
      this.unsubmittedDataSource.data.forEach(row => this.unsubmittedSelection.select(row));
    this.selectedCount = this.unsubmittedSelection.selected.length;
  }

  isAllSubmittedDraftSelected() {
    const numSelected = this.submittedSelection.selected.length;
    const numRows = this.submittedDataSource.data.length;
    return numSelected === numRows;
  }

  masterToggleSubmitted() {
    this.isAllSubmittedDraftSelected() ?
      this.submittedSelection.clear() :
      this.submittedDataSource.data.forEach(row => this.submittedSelection.select(row));
    this.selectedSubmittedCount = this.submittedSelection.selected.length;
  }

  navigateToReleaseOrderInfo(obj: any, caller: string) {
    if (caller == 'S') {
      var accountNumber = obj.accountNumber;
      var releaseId = obj.releaseId;
      this.seedFulfillmentService.submitedItem = true;
      this.router.navigate(['/seed-fulfillment', accountNumber, releaseId]);
    }
    else {
      var accountNumber = obj.accountNumber;
      var releaseId = obj.releaseId;
      this.seedFulfillmentService.submitedItem = false;
      this.router.navigate(['/seed-fulfillment', accountNumber, releaseId]);
    }
  }

  unsubmittedCheckEvent(row, isChecked: boolean) {
    this.unsubmittedSelection.toggle(row);
    if (isChecked == true) {
      this.selectedCount = this.selectedCount + 1;
    }
    else {
      this.selectedCount = this.selectedCount - 1;
    }
  }

  submittedCheckEvent(row, isChecked: boolean) {
    this.submittedSelection.toggle(row);
    if (isChecked == true) {
      this.selectedSubmittedCount = this.selectedSubmittedCount + 1;
    }
    else {
      this.selectedSubmittedCount = this.selectedSubmittedCount - 1;
    }
  }

  filterGrid(e: any) {
    if (e == null) {
      this.seedFulfillmentFilter = null;
      this.getUnsubmittedDraftList();
      this.getSubmittedRequestList();
    }
    else {
      this.seedFulfillmentFilter = {
        AccountName: (e && e.accountName) ? e.accountName : '',
        AccountNumber: (e && e.accountNo) ? e.accountNo : 0,
        City: (e && e.city) ? e.city : '',
        State: (e && e.state) ? e.state : '',
        ProductName: (e && e.productName) ? e.productName : '',
        ItemNumber: (e && e.itemNumber) ? e.itemNumber : '',
        MarketingBrand: (e && e.marketingBrand) ? e.marketingBrand : '',
        SeedSize: (e && e.seedSize) ? e.seedSize : '',
        PackageSize: (e && e.packageSize) ? e.packageSize : '',
        ProductCategory: (e && e.productCategory) ? e.productCategory : '',
        Treatment: (e && e.treatment) ? e.treatment : '',
        ProductLine: (e && e.productLine) ? e.productLine : '',
        ProductSegment: (e && e.productSegment) ? e.productSegment : '',
        HybridVariety: (e && e.hybridVariety) ? e.hybridVariety : '',
        ZipCode: (e && e.dealerZip) ? e.dealerZip : '',
        BranchPlant: (e && e.branchPlant) ? e.branchPlant : '',
        OrderType: (e && e.orderType) ? e.orderType : ''
      };
      this.loaderService.setLoaderStatus(true);

      const forkJoinAPIs = [];
      forkJoinAPIs.push(this.seedFulfillmentService.getFilteredUnSubmittedReleaseOrder(this.seedFulfillmentFilter));
      forkJoinAPIs.push(this.seedFulfillmentService.getFilteredSubmittedReleaseOrder(this.seedFulfillmentFilter));
      this.subscription.push(forkJoin(forkJoinAPIs).subscribe((result: any[]) => {
        this.unsubmittedList = result[0];
        this.unsubmittedDataSource = new MatTableDataSource(this.unsubmittedList);
        this.unsubmittedDataSource.paginator = this.unSubmittedPaginator;
        this.unsubmittedDataSource.paginator.firstPage();
        this.unsubmittedDataSource.sort = this.unSubmittedSort;

        this.submittedList = result[1];
        this.submittedDataSource = new MatTableDataSource(this.submittedList);
        this.submittedDataSource.paginator = this.submittedPaginator;
        this.submittedDataSource.paginator.firstPage();
        this.submittedDataSource.sort = this.submittedSort;

        this.loaderService.setLoaderStatus(false);
      }, () => this.loaderService.setLoaderStatus(false)));
    }
  }

  ngOnDestroy() {
    this.subscription.forEach(subscription => subscription.unsubscribe());
  }
}
